export default {
    cz: {
        addToCart: {
            success: 'Produkt byl přidán do košíku.',
            error: 'Nepodařilo se přidat produkt do košíku.',
        },
    },
    sk: {
        addToCart: {
            success: 'Produkt bol pridaný do košíka.',
            error: 'Nepodarilo sa pridať produkt do košíka.',
        },
    },
}
